<template>
    <div class="footerImages">
        <img v-if="image1.display"  :src="image1.url" alt="" @click="goToPath(image1.redirectUrl)">
        <div class="middleTextImg">
            <img v-if="image2.display"  :src="image2.url" alt=""  @click="goToPath(image2.redirectUrl)">
            <div v-if="itemData?.htmlFooterTextTop?.display" class="middleText" v-html="footerTextTop"></div>
        </div>

        <img v-if="image3.display"  :src="image3.url" alt="" @click="openContactPopup">
    </div>
    <div class="footerImages">
        <img v-if="image4.display"  :src="image4.url" alt=""  @click="goToPath(image4.redirectUrl)">
    </div>
    <div class="footerImages2">
        <img v-if="image5.display"  :src="image5.url" alt=""  @click="goToPath(image1.redirectUrl)">
    </div>

</template>

<script setup lang="ts">
import { FooterImagesItem, useNavigation } from '@/view/home/supportScript';
import { computed} from 'vue'

function resolveText(text: string | Record<string, string>): string {
  if (typeof text === 'string') return text
  const lang = localStorage.getItem('lang') || 'en'
  return text[lang] || text['en'] || ''
}

function resolveImage(item: FooterImagesItem | Record<string, FooterImagesItem>): FooterImagesItem {
  if (!item) return { display: false, url: '', redirectUrl: '' }
  if ('url' in item) return item as FooterImagesItem
  const lang = localStorage.getItem('lang') || 'en'
  const localized = item as Record<string, FooterImagesItem>
  return localized[lang] || localized['en'] || { display: false, url: '', redirectUrl: '' }
}

const { goToPath } = useNavigation()
const emits = defineEmits(['openContactPopup'])
const props = defineProps<{
    itemData: {
        footerImage1: FooterImagesItem | Record<string, FooterImagesItem>,
        footerImage2: FooterImagesItem | Record<string, FooterImagesItem>,
        footerImage3: FooterImagesItem | Record<string, FooterImagesItem>,
        footerImage4: FooterImagesItem | Record<string, FooterImagesItem>,
        footerImage5: FooterImagesItem | Record<string, FooterImagesItem>,
        htmlFooterTextTop: {
            display : boolean
            text: string | Record<string, string>
        }
    }
}>()
const image1 = computed(() => resolveImage(props.itemData.footerImage1))
const image2 = computed(() => resolveImage(props.itemData.footerImage2))
const image3 = computed(() => resolveImage(props.itemData.footerImage3))
const image4 = computed(() => resolveImage(props.itemData.footerImage4))
const image5 = computed(() => resolveImage(props.itemData.footerImage5))
const footerTextTop = computed(() => resolveText(props.itemData.htmlFooterTextTop?.text || ''))
const openContactPopup = () => {
    emits('openContactPopup')
}
</script>
<style scoped>
.footerImages {
    padding: 10px 10px 20px;
    border-bottom: 2px solid #b9b386;
}

.footerImages img {
    width: 100%;
}

.footerImages2 {
    padding: 10px 20px;
}

.footerImages2 img {
    width: 100%;
}

.middleTextImg {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 15px 10px;
}

.middleTextImg img {
    width: 120px;
}

.middleText {
    color: #fff;
    font-size: 15px;
    padding: 15px 0;
    text-align: center;
}
</style>